// * Bootstrap libraries
import "./_bootstrap";

// * Any other global site-wide JavaScript should be placed below.
